import { globalPartnerPlanPage } from '../configs'

export const isGlobalPartnerPlanPage = (pathname: string) => {
  return pathname.includes(globalPartnerPlanPage)
}
